module.exports = __webpack_public_path__ + "static/media/resetBalance.3c9e318b.webp";